import { render, staticRenderFns } from "./PoseLandmarkerTest.vue?vue&type=template&id=2bfd51d3&scoped=true&"
import script from "./PoseLandmarkerTest.vue?vue&type=script&lang=js&"
export * from "./PoseLandmarkerTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfd51d3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bfd51d3')) {
      api.createRecord('2bfd51d3', component.options)
    } else {
      api.reload('2bfd51d3', component.options)
    }
    module.hot.accept("./PoseLandmarkerTest.vue?vue&type=template&id=2bfd51d3&scoped=true&", function () {
      api.rerender('2bfd51d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/test/camera/pose-landmarker/PoseLandmarkerTest.vue"
export default component.exports